export default [
  // routes
  {
    name: 'rates',
    path: '/tabelas',
    component: () => import('@/views/RatesList.vue'),
    props: true,
  },
  {
    name: 'rates-edit',
    path: '/tabelas/:id',
    component: () => import('@/views/RatesEdit.vue'),
    props: true,
  },

  // redirects
  // ...
];
